import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const ArrowBackIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="arrow-left" {...props} />;
};

export { ArrowBackIcon };
